import { __decorate, __spread, __metadata } from 'tslib';
import { Injectable, Input, Output, Component, EventEmitter, HostListener, Directive, NgModule } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { UkFormControlsModule } from '@uikit/components/uk-form-controls';
import { OBJECT_TO_ARRAY } from '@uikit/components/uk-utils';
import { UkRadioModule } from '@uikit/components/uk-radio';
import { UkCheckboxModule } from '@uikit/components/uk-checkbox';
import { UkDropdownModule } from '@uikit/components/uk-dropdown';

var UkFormlyService = /** @class */ (function () {
    function UkFormlyService() {
    }
    Object.defineProperty(UkFormlyService.prototype, "form", {
        get: function () { return this._form; },
        set: function (form) {
            this._form = form;
        },
        enumerable: true,
        configurable: true
    });
    UkFormlyService = __decorate([
        Injectable()
    ], UkFormlyService);
    return UkFormlyService;
}());

var TypeWithAllowedOptions = [
    'select',
    'checkbox',
    'radio'
];
var UkFormlyComponent = /** @class */ (function () {
    function UkFormlyComponent(fb, formlyService) {
        this.fb = fb;
        this.formlyService = formlyService;
        this.formValues = new EventEmitter();
        this.objectToArray = OBJECT_TO_ARRAY;
    }
    Object.defineProperty(UkFormlyComponent.prototype, "fields", {
        get: function () { return this._fields; },
        set: function (value) {
            this._fields = __spread(value);
            this.checkTypeControls();
            this.setFormControls();
        },
        enumerable: true,
        configurable: true
    });
    UkFormlyComponent.prototype.getErrorMessage = function (key, error, formField) {
        var control = this.fields.find(function (field) { return field.key === key; });
        if (control.validators || control.asyncValidators) {
            var validator_1 = control.validators ?
                control.validators.find(function (v) { return v.key === error.key; }) :
                control.asyncValidators.find(function (v) { return v.key === error.key; });
            // tslint:disable-next-line: curly
            if (!validator_1)
                return;
            var fieldControl = formField.control;
            var generatedMessage = function () { return validator_1.message; };
            fieldControl.removeError(key);
            fieldControl.setError(key, { name: error.key, message: generatedMessage });
        }
    };
    UkFormlyComponent.prototype.setFormControls = function () {
        var fields = {};
        this.fields.map(function (field) {
            fields[field.key] = [
                field.templateOptions.value || '',
                (field.validators) ? field.validators.map(function (v) { return v.validator; }) : null,
                (field.asyncValidators) ? field.asyncValidators.map(function (v) { return v.validator; }) : null
            ];
        });
        this.form = this.fb.group(fields);
        this.formlyService.form = this.form;
    };
    UkFormlyComponent.prototype.checkTypeControls = function () {
        this.fields.map(function (x) {
            if (x.templateOptions.options && x.templateOptions.options.length > 0 && !TypeWithAllowedOptions.includes(x.type)) {
                throw Error("Type " + x.type + " doesn't support options argument in " + x.key);
            }
            if (TypeWithAllowedOptions.includes(x.type) && (!x.templateOptions.options || x.templateOptions.options.length === 0)) {
                throw Error("Type " + x.type + " needs atleast one option argument in " + x.key);
            }
        });
    };
    __decorate([
        Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], UkFormlyComponent.prototype, "fields", null);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], UkFormlyComponent.prototype, "formValues", void 0);
    UkFormlyComponent = __decorate([
        Component({
            selector: 'uk-formly',
            template: "<ng-container>\r\n  <form [formGroup]=\"form\">\r\n    <ng-container *ngFor=\"let field of fields\">\r\n      <ng-container [ngSwitch]=\"field.type\">\r\n        <uk-form-field #formField *ngSwitchCase=\"'textarea'\"\r\n        [label]=\"field.templateOptions.label\"\r\n        [hint]=\"field.templateOptions.description\">\r\n          <textarea ukInput \r\n          [required]=\"field.templateOptions.required\" \r\n          [placeholder]=\"field.templateOptions.placeholder\"\r\n          [formControlName]=\"field.key\">\r\n          ></textarea>\r\n          <ng-container \r\n            *ngTemplateOutlet=\"errorsTemplate;context:{form: form, field:field, formfield: formField}\">\r\n          </ng-container>\r\n        </uk-form-field>\r\n\r\n        <uk-form-field #formField *ngSwitchCase=\"'radio'\"\r\n        [label]=\"field.templateOptions.label\"\r\n        [hint]=\"field.templateOptions.description\">\r\n          <uk-radio-group [formControlName]=\"field.key\" aligment=\"horizontal\" \r\n          [required]=\"field.templateOptions.required\">\r\n            <uk-option [value]=\"option.value\" *ngFor=\"let option of field.templateOptions.options\">\r\n              {{option.label}}\r\n            </uk-option>\r\n          </uk-radio-group>\r\n        </uk-form-field>\r\n        \r\n        <uk-form-field #formField *ngSwitchCase=\"'checkbox'\"\r\n          [label]=\"field.templateOptions.label\"\r\n          [hint]=\"field.templateOptions.description\">\r\n          <uk-checkbox-group [formControlName]=\"field.key\"\r\n          [required]=\"field.templateOptions.required\">\r\n            <uk-option [value]=\"option.value\" *ngFor=\"let option of field.templateOptions.options\">\r\n              {{option.label}}\r\n            </uk-option>\r\n          </uk-checkbox-group>\r\n        </uk-form-field>\r\n\r\n        <uk-form-field #formField *ngSwitchCase=\"'select'\"\r\n          [label]=\"field.templateOptions.label\"\r\n          [hint]=\"field.templateOptions.description\">\r\n          <uk-dropdown [formControlName]=\"field.key\"\r\n          [required]=\"field.templateOptions.required\" \r\n          [placeholder]=\"field.templateOptions.placeholder\"> \r\n            <uk-option [value]=\"option.value\" *ngFor=\"let option of field.templateOptions.options\">\r\n              {{option.label}}\r\n            </uk-option>\r\n          </uk-dropdown>\r\n        </uk-form-field>\r\n\r\n        <uk-form-field #formField *ngSwitchDefault \r\n        [label]=\"field.templateOptions.label\"\r\n        [hint]=\"field.templateOptions.description\">\r\n          <input ukInput \r\n          [type]=\"field.type\"\r\n          [required]=\"field.templateOptions.required\" \r\n          [placeholder]=\"field.templateOptions.placeholder\"\r\n          [formControlName]=\"field.key\">\r\n          <ng-container \r\n            *ngTemplateOutlet=\"errorsTemplate;context:{form: form, field:field, formfield: formField}\">\r\n          </ng-container>\r\n        </uk-form-field>\r\n      </ng-container>\r\n    </ng-container>\r\n  </form> \r\n</ng-container>\r\n\r\n\r\n<ng-template #errorsTemplate let-form=\"form\" let-field=\"field\" let-formfield=\"formfield\">\r\n  <ng-container *ngIf=\"form.get(field.key).errors\">\r\n    <ng-container *ngFor=\"let error of objectToArray(form.get(field.key).errors)\">\r\n      {{ getErrorMessage(field.key, error, formfield) }}\r\n    </ng-container>\r\n  </ng-container>\r\n</ng-template>"
        }),
        __metadata("design:paramtypes", [FormBuilder,
            UkFormlyService])
    ], UkFormlyComponent);
    return UkFormlyComponent;
}());

var SubmitDirective = /** @class */ (function () {
    function SubmitDirective(formlyService) {
        this.formlyService = formlyService;
        this.formValues = new EventEmitter();
    }
    SubmitDirective.prototype.handleClick = function () {
        this.returnValues();
    };
    SubmitDirective.prototype.returnValues = function () {
        var _this = this;
        if (this.formlyService.form.valid) {
            var values = this.formlyService.form.value;
            this.formValues.emit(values);
        }
        else {
            Object.keys(this.formlyService.form.controls).map(function (key) {
                _this.formlyService.form.controls[key].markAsTouched();
            });
        }
    };
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], SubmitDirective.prototype, "formValues", void 0);
    __decorate([
        HostListener('click', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SubmitDirective.prototype, "handleClick", null);
    SubmitDirective = __decorate([
        Directive({
            selector: 'button[ukFormlySubmit]'
        }),
        __metadata("design:paramtypes", [UkFormlyService])
    ], SubmitDirective);
    return SubmitDirective;
}());

var UkFormlyModule = /** @class */ (function () {
    function UkFormlyModule() {
    }
    UkFormlyModule = __decorate([
        NgModule({
            imports: [
                ReactiveFormsModule,
                CommonModule,
                UkFormControlsModule,
                UkRadioModule,
                UkCheckboxModule,
                UkDropdownModule
            ],
            declarations: [
                UkFormlyComponent,
                SubmitDirective
            ],
            exports: [
                UkFormlyComponent,
                SubmitDirective
            ],
            providers: [
                UkFormlyService
            ]
        })
    ], UkFormlyModule);
    return UkFormlyModule;
}());

var UkTypeField;
(function (UkTypeField) {
    UkTypeField["textarea"] = "textarea";
    UkTypeField["radio"] = "radio";
    UkTypeField["checkbox"] = "checkbox";
    UkTypeField["select"] = "select";
    UkTypeField["text"] = "text";
    UkTypeField["email"] = "email";
    UkTypeField["number"] = "number";
})(UkTypeField || (UkTypeField = {}));

export { UkFormlyModule, UkTypeField, UkFormlyComponent as ɵa, UkFormlyService as ɵb, SubmitDirective as ɵc };
//# sourceMappingURL=uikit-components-uk-formly.js.map
